// @gqlflow
import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {getFeedbackReplies as FeedbackRepliesData} from "./__graphql-types__/getFeedbackReplies.ts";
import type {
    getFeedbackRepliesPage as FeedbackRepliesPageData,
    getFeedbackRepliesPageVariables as FeedbackRepliesPageVars,
} from "./__graphql-types__/getFeedbackRepliesPage.ts";

type FeedbackRepliesVariables = {
    postKey: string;
};

export const FEEDBACK_REPLIES_QUERY: GqlOperation<
    FeedbackRepliesData,
    FeedbackRepliesVariables
> = gqlOp(gql`
    query getFeedbackReplies($postKey: String!) {
        feedbackReplies(feedbackKey: $postKey) {
            isLocked
            isPinned
            expandKey
            appearsAsDeleted
            author {
                id
                kaid
                nickname
                avatar {
                    name
                    imageSrc
                }
            }
            content
            date
            definitelyNotSpam
            deleted
            downVoted
            expandKey
            feedbackType
            flaggedBy
            flaggedByUser
            flags
            focusUrl
            fromVideoAuthor
            key
            lowQualityScore
            notifyOnAnswer
            permalink
            qualityKind
            replyCount
            replyExpandKeys
            showLowQualityNotice
            sumVotesIncremented
            upVoted
        }
    }
`);

export const FEEDBACK_REPLIES_PAGINATED_QUERY: GqlOperation<
    FeedbackRepliesPageData,
    FeedbackRepliesPageVars
> = gqlOp(gql`
    query getFeedbackRepliesPage(
        $postKey: String!
        $cursor: String
        $limit: Int!
    ) {
        feedbackRepliesPaginated(
            feedbackKey: $postKey
            cursor: $cursor
            limit: $limit
        ) {
            cursor
            isComplete
            feedback {
                isLocked
                isPinned
                expandKey
                appearsAsDeleted
                author {
                    id
                    kaid
                    nickname
                    avatar {
                        name
                        imageSrc
                    }
                }
                content
                date
                definitelyNotSpam
                deleted
                downVoted
                expandKey
                feedbackType
                flaggedBy
                flaggedByUser
                flags
                focusUrl
                fromVideoAuthor
                key
                lowQualityScore
                notifyOnAnswer
                permalink
                qualityKind
                replyCount
                replyExpandKeys
                showLowQualityNotice
                sumVotesIncremented
                upVoted
            }
        }
    }
`);
